import {
  useAlerting,
  // useListMappingTransform,
  usePermission,
  useTranslation,
} from "src/hooks";
import {
  downloadFiles,
  getFullApiResponse,
  listMappingTransform,
} from "src/utils/helper";
import { usePageConfigProviderContext } from "..";
import GeneralBtn from "src/components/GeneralBtn";
import { DefaultListParams } from "src/features/common/types/DefaultListParams";

//Export Button type
export type ExportButtonProps<GetListRes> = {
  fileName: string;
  permissionKey: string;
  omitKeys?: string[];
  isTheSameAsTableApi?: true;
  mapResultToTupleArray: (rows: GetListRes[], omitKeys: string[]) => any[][][];
  exportTableApiFunc: (
    params: DefaultListParams,
    { signal }: { signal: AbortSignal }
  ) => Promise<any>;
};

const ExportButton = <FilterFieldsType, GetListRes>(
  props: ExportButtonProps<GetListRes>
) => {
  const {
    fileName,
    permissionKey,
    omitKeys,
    isTheSameAsTableApi,
    mapResultToTupleArray,
    exportTableApiFunc,
    ...rest
  } = props;
  const { translatePrefix, fields, list, getListParams } =
    usePageConfigProviderContext<FilterFieldsType, GetListRes>();

  const { alerting } = useAlerting();
  const { tc } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  const onExport = async () => {
    const params = getListParams(fields);
    const { currentTime, ...cleanParams } = params;
    if (list.count === 0) {
      return alerting("error", tc("no_data_export"));
    }
    const apiFn = (page: number, pageSize: number, signal: AbortSignal) =>
      exportTableApiFunc({ ...cleanParams, page, pageSize }, { signal });
    const rawRes = await getFullApiResponse(
      apiFn,
      list.count,
      !isTheSameAsTableApi
    );
    if (rawRes.length === 0) return;
    const res = mapResultToTupleArray(rawRes, omitKeys ?? ["rawData"]);
    const output = res.map(listMappingTransform("name"));
    downloadFiles(fileName, output, {});
  };

  return (
    <GeneralBtn
      label="export"
      onClick={onExport}
      isHidden={!hasPermission(permissionKey)}
      {...rest}
    />
  );
};

export default ExportButton;
